export const SITE_DESCRIPTION = 'Stay up to date with upcoming IPOs'

export const PROD_SITE_URL = 'https://ipo-calendar.netlify.app/'

export const SITE_META = {
  title: 'View upcoming IPO information with the dedicated IPO Calendar site',
  description: 'IPO Calendar lets you search for upcoming IPOs and past IPOs',
  hashtags: [
    'IPO',
    `IPO${new Date().getFullYear()}`,
    'IPOCalendar',
    'upcomingIPO',
  ],
  source: PROD_SITE_URL,
}
